import React from "react";

const FormDataContext = React.createContext({ data: {}, setData: () => {} });

export default FormDataContext;
